/**************************************************
 * Nombre:       Formulario_Documento_Requerido
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    ArticleOutlined,
    BadgeOutlined,
    DiamondOutlined,
    Flag,
    Google
} from "@mui/icons-material";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOCUENTA, TIPODOCSREQ} from "../../../Constantes";

const Formulario_Documento_Requerido = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Tipo'} dato={'tipo'} {...props}
                                   requerido={'El tipo es requerido'}
                                   opciones={TIPODOCSREQ}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={ArticleOutlined} nombre={'Nombre del documento'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={4} nombre={'Descripcion del documento'} dato={'descripcion'} {...props}

                    />
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Documento_Requerido